export default {
  name: "nonMCareCustomers",
  props: {
    settings: null,
    arecheckedesdisabled: Boolean,
    facility: null,
  },
  computed: {
    nonMCareCustomersCategory: {
      get() {
        const f = this.facility;

        const conditions = [
          !f.isEnableADT || (
            (f.featureNonMCareCustomers ?? true) &&
            (f.isEnableCSVImportForResidents ?? true) &&
            (f.isEnableManuallyAddDeleteResidents ?? true)
          )
        ];

        return conditions
          .filter(v => v !== undefined && v !== null)
          .every(Boolean);
      }
    },
    isDisabled() {
      return this.facility.isEnableADT;
    }
  },
  methods: {
    nonMCareCustomersUpdate(value) {
      if(!this.facility.isEnableADT) {
        this.facility.featureNonMCareCustomers = value;
        this.facility.isEnableCSVImportForResidents = value;
        this.facility.isEnableManuallyAddDeleteResidents = value;
      }
    }
  }
}